type Props = {
  placementId: string;
  containerId?: string;
  adIndex: number;
  categories: string;
  initialLayoutType?: string;
};
export function injectRecircSlotInWebComponent(props: Props) {
  if (typeof window !== 'undefined') {
    const webComponent = getRecircWebComponent();
    if (webComponent && props?.placementId) {
      const advtComponent = getAdvtWebComponent(props);

      const recircSlotId = `${props.placementId}--recirc-slot`;
      advtComponent.setAttribute('slot', recircSlotId);
      advtComponent.setAttribute('id', recircSlotId);

      webComponent.appendChild(advtComponent);
    }
  }
}

export function getRecircWebComponent() {
  return (
    document.querySelector('recommendation-podlet-isolated') ||
    document.querySelector('recommendation-podlet-mock') ||
    document.querySelector('data-podlet-mlt') ||
    document.querySelector('data-podlet-recommend') ||
    // recommendation-podlet-mock is only used to mimic the recirculation slot in the local environment
    // no other layour server or podlet should be defining this web component
    document.querySelector('recommendation-podlet-mock')
  );
}

export function getAdvtWebComponent({
  placementId,
  containerId,
  adIndex,
  categories,
  initialLayoutType
}: Props) {
  const advtComponent = document.createElement('advt-component');
  advtComponent.setAttribute('placementId', placementId);
  advtComponent.setAttribute('adIndex', `${adIndex}`);
  advtComponent.setAttribute(
    'containerId',
    containerId || `${placementId}--container`
  );
  advtComponent.setAttribute('categories', categories);
  advtComponent.setAttribute('initialLayoutType', initialLayoutType || 'grid');

  return advtComponent;
}
